var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.823413,
    y: 0.823413,
    width: 51.0516,
    height: 51.0516,
    rx: 25.5258,
    fill: "#1E1E1E",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.823413,
    y: 0.823413,
    width: 51.0516,
    height: 51.0516,
    rx: 25.5258,
    stroke: "white",
    strokeWidth: 1.64683
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9657 23.5009C37.4825 23.7757 37.9149 24.186 38.2163 24.6878C38.5178 25.1895 38.6771 25.7639 38.6771 26.3492C38.6771 26.9346 38.5178 27.5089 38.2163 28.0107C37.9149 28.5125 37.4825 28.9227 36.9657 29.1976L23.1791 36.6946C20.9592 37.903 18.2324 36.3319 18.2324 33.8473V18.8522C18.2324 16.3665 20.9592 14.7965 23.1791 16.0028L36.9657 23.5009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.009ca0379f5e780f0e339414a917136c.svg";
export { ForwardRef as ReactComponent };